import script from "./ServiceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSection.vue?vue&type=script&setup=true&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=0193633d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0193633d"]])

export default __exports__